import API from "../api";

export const postSession = ({ interview, person, agent } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post("/interviews/sessions/", { interview, person, agent })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => reject(err.response?.data || err));
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const fetchUsers = async ({ signal, pageSize = 200 } = {}) => {
  try {
    const response = await API.get(`/auth/users/`, {
      params: { page_size: pageSize },
      signal,
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch users.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const fetchSessions = async ({
  params: { interviewId, search, workflowStatus, ordering, page, pageSize } = {},
  signal,
} = {}) => {
  try {
    const response = await API.get('/interviews/sessions/', {
      params: {
        interview: interviewId,
        search,
        workflow_status: workflowStatus,
        ordering,
        page,
        page_size: pageSize,
      },
      signal,
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch sessions.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const fetchSessionAdminSummary = ({ interviewId, signal } = {}) =>
  API.get('/interviews/sessions/admin_summary/', {
    params: { interview: interviewId },
    signal,
  }).then((response) => response.data);

export const fetchOneSessionUser = async ({
  params: { userUuid },
  signal,
} = {}) => {
  try {
    const response = await API.get(`/auth/users/${userUuid}/`, {
      signal,
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch user.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const fetchOneSession = async ({
  params: { sessionId, interviewId },
  signal,
} = {}) => {
  try {
    const response = await API.get(
      `/interviews/sessions/${sessionId}/?interview=${interviewId}`,
      {
        signal,
      }
    );
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch session.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

export const postOneSessionQuestion = async (data) => {
  const formattedData = {
    session: data.sessionId,
    interview_question: data.interviewQuestionId,
    agent: data.agent,
  };

  console.log(formattedData);

  try {
    const response = await API.post(
      `/interviews/sessions/interview-question/`,
      formattedData
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteOneSession = async ({ params: { sessionId } } = {}) => {
  try {
    const response = await API.delete(`/interviews/sessions/${sessionId}/`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchAgents = async ({ signal } = {}) => {
  try {
    const response = await API.get(`/interviews/agents/`, {
      signal,
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (err) {
    const errorMsg = err || "Failed to fetch agents.";
    return {
      success: false,
      error: errorMsg,
    };
  }
};
